export const vi = {
  hero: {
    subtitle: "Giải pháp xuất nhập khẩu đáng tin cậy",
    title: "ĐƠN GIẢN HÓA THƯƠNG MẠI TOÀN CẦU. CHÚNG TÔI KẾT NỐI THỊ TRƯỜNG.",
    highlight:
      "Mang lại giá trị bằng sự tin cậy, hiệu quả và phạm vi toàn cầu.",
    cta: "Tìm hiểu thêm",
  },
  nav: {
    home: "TRANG CHỦ",
    about: "VỀ CHÚNG TÔI",
    products: "SẢN PHẨM",
    testimonials: "ĐÁNH GIÁ KHÁCH HÀNG",
    contact: "LIÊN HỆ",
  },
  about: {
    subtitle: "Về Chúng Tôi",
    title: "GIAO DỊCH MATRION",
    description:
      "Matrion specialize in providing reliable import and export solutions for businesses related to Vietnamese-made products. With a professional team and network with manufacturers, Matrion will source best products with reasonable price and ensure your transaction to make in-time global delivery.",
    cta: "Read More",

    factsSubtitle1: "WHY CHOOSE MATRION?",
    factsTitle1:
      "#1 Matrion tư vấn giải pháp AZ cho các doanh nghiệp trong nhiều ngành công nghiệp khác nhau.",
    factsDescription1:
      "Chúng tôi hiểu nỗ lực của bạn trong kinh doanh và chúng tôi ở đây để thiết kế và tạo ra những món quà tuyệt vời cho khách hàng của bạn.",
    // ________
    factsTitle2:
      "#2 Matrion đảm bảo tiêu chuẩn chất lượng cao cho tất cả sản phẩm.",
    factsDescription2:
      "Chúng tôi phục vụ khách hàng toàn cầu và đảm bảo tiêu chuẩn xuất khẩu chất lượng cao cho tất cả các sản phẩm. ",
    // ________
    factsTitle3:
      "#3 Matrion cung cấp dịch vụ lưu trữ và giao hàng đúng thời hạn. ",
    factsDescription3:
      "Chúng tôi cung cấp nhiều lựa chọn về thanh toán, lưu trữ và giao hàng cho doanh nghiệp của bạn, tiết kiệm thời gian của bạn thay vì phải làm việc với nhiều nhà sản xuất riêng biệt.",
    // ________
    factsTitle4: "#4 Matrion mang đến cho bạn mức giá cạnh tranh.",
    factsDescription4:
      "Chúng tôi có kinh nghiệm trong cả xuất khẩu (chứng nhận xuất khẩu) và giao dịch tại Việt Nam, mức thanh toán của bạn luôn xứng đáng và cạnh tranh. ",
    // clients: "Khách hàng hài lòng",
    // shipments: "Lô hàng đã hoàn tất",
    // reviews: "Đánh giá từ khách hàng",
  },
  services: {
    subtitle: "Dịch Vụ",
    title: "Khám Phá Dịch Vụ Của Chúng Tôi",
    description:
      "Chúng tôi là nhà nhập khẩu và phân phối sản phẩm chất lượng cho nhiều lĩnh vực.",
    cta: "Tìm hiểu thêm",
    items: {
      1: { title: "Nón bảo hiểm xe máy" },
      2: { title: "Mũ/Nón lưỡi trai" },
      3: { title: "Áo thun/Áo Polo" },
      4: { title: "Túi vải dệt/Túi vải không dệt" },
      5: { title: "Ô dù" },
      6: { title: "Cờ phướn" },
      7: { title: "Thẻ treo hành lý" },
      8: { title: "Ly giữ nhiệt" },
      9: { title: "Bút" },
      10: { title: "Balo dây rút" },
      11: { title: "Áo mưa" },
      12: { title: "Sổ tay" },
    },
  },
  features: {
    subtitle: "Tính Năng Nổi Bật",
    title: "Chúng tôi là công ty logistics đáng tin cậy từ năm 1990",
    items: {
      1: "Dịch vụ toàn cầu",
      2: "Giao hàng đúng hạn",
      3: "Hỗ trợ điện thoại 24/7",
    },
  },
  contact: {
    subtitle: "Nhận báo giá",
    title: "Yêu cầu báo giá miễn phí!",
    description: "Chúng tôi luôn sẵn sàng hỗ trợ bạn...",
    callLabel: "Liên hệ ngay!",
    name: "Họ tên",
    email: "Email",
    phone: "Số điện thoại",
    message: "Nội dung",
    freightOption: "Chọn loại vận chuyển",
    send: "Gửi đi",
    sending: "Đang gửi...",
  },
  freight: {
    air: "Vận chuyển hàng không",
    sea: "Vận chuyển đường biển",
    road: "Vận chuyển đường bộ",
  },
  testimonials: {
    subtitle: "ĐÁNH GIÁ KHÁCH HÀNG",
    title: "Phản hồi từ khách hàng chiến lược của chúng tôi",
    items: [
      {
        name: "Leslie Alexander",
        company: "FERRARI",
        message:
          "Dịch vụ vận chuyển rất nhanh chóng và hiệu quả. Hàng hóa đến nơi đúng hẹn và nguyên vẹn!",
      },
      {
        name: "Annette Black",
        company: "LOUIS VUITTON",
        message:
          "Chúng tôi hợp tác với MATRION trong nhiều năm. Dịch vụ và giải pháp logistics rất chuyên nghiệp.",
      },
      {
        name: "Ralph Edwards",
        company: "MITSUBISHI",
        message:
          "Đối tác đáng tin cậy trong chuỗi cung ứng quốc tế của chúng tôi. Rất đáng để hợp tác!",
      },
      {
        name: "Esther Howard",
        company: "TESLA",
        message:
          "Dịch vụ chăm sóc khách hàng tốt, theo dõi vận chuyển thời gian thực. MATRION đã vượt mong đợi!",
      },
      {
        name: "Jenny Wilson",
        company: "AMAZON",
        message:
          "Toàn bộ quá trình từ nhận hàng đến giao hàng đều rất trơn tru và chuyên nghiệp.",
      },
      {
        name: "Devon Lane",
        company: "NIKE",
        message:
          "Nhờ MATRION, chúng tôi đã mở rộng thị trường toàn cầu một cách tự tin và hiệu quả.",
      },
    ],
  },
  footer: {
    address: {
      title: "Địa chỉ",
      line1:
        "4/7 Đường Xuân Thới Thượng 6, Xã Xuân Thới Thượng, Huyện Hóc Môn, Thành Phố Hồ Chí Minh",
      phone: "(84) 969441533",
      phone2: "(84) 969009553",
      email: "matrionvn@gmail.com",
    },
    products: {
      title: "Sản phẩm",
      chemicals: "Hóa chất nông nghiệp",
      industrial: "Hóa chất công nghiệp",
      pigments: "Chất tạo màu",
      lubricant: "Dầu nhớt",
      detergent: "Chất tẩy rửa",
      tyres: "Lốp xe",
    },
    links: {
      title: "Liên kết nhanh",
      home: "Trang chủ",
      about: "Về chúng tôi",
      careers: "Tuyển dụng",
      contact: "Liên hệ",
    },
    newsletter: {
      title: "Đăng ký nhận tin",
      desc: "Đăng ký để nhận những tin tức và cập nhật mới nhất từ chúng tôi.",
      placeholder: "Nhập email của bạn",
    },
    copyright:
      "CÔNG TY TNHH THƯƠNG MẠI VÀ XUẤT NHẬP KHẨU MATRION - Mã số doanh nghiệp: 0318842287 - Giấy chứng nhận đăng ký doanh nghiệp do Sở Kế hoạch và Đầu tư TP.Hồ Chí Minh cấp lần đầu ngày 21/02/2025 .",
  },
};
